import {
  isNotEmptyObject,
  isNotNullOrUndefinedorEmpty,
} from '@next-app/utils/common-utils';
import { CartState } from './ShoppingCart.interface';

export const selectShoppingCartState = (state: CartState) =>
  state.cart.ShoppingCartData;

export const selectIsShoppingCartDataLoaded = (state: CartState) => {
  return isNotEmptyObject(selectShoppingCartState(state));
};

export const selectHeader = (state: CartState) => {
  return selectShoppingCartState(state)?.header;
};

export const selectCartSummary = (state: CartState) => {
  return selectShoppingCartState(state)?.cartSummary;
};

export const selectAllLines = (state: CartState) => {
  return selectShoppingCartState(state)?.allLines;
};

export const selectUnavailableLines = (state: CartState) => {
  return selectShoppingCartState(state)?.unavailableLines;
};

export const selectLoyaltyInfo = (state: CartState) => {
  return selectHeader(state)?.loyaltyInfo;
};

export const selectGooglePayPaymentRequest = (state: any) => {
  return selectShoppingCartState(state)?.googlePayPaymentRequest;
};

export const selectShowClearTheListAddressModal = (state: any) => {
  return selectHeader(state)?.showClearTheListAddressModal;
};

export const selectIsRegistryOrder = (state: any) => {
  return selectHeader(state)?.registryOrder;
};

export const selectIsPaypalEnabledForCart = (state: any) => {
  return selectHeader(state)?.isPaypalEnabledForCart;
};

export const selectIsApplePayEnabledForCart = (state: any) => {
  return selectHeader(state)?.isApplePayEnabledForCart;
};

export const selectDisableCheckout = (state: any) => {
  return selectHeader(state)?.disableCheckout;
};

export const selectIsGooglePayEnabledForCart = (state: any) => {
  return isNotNullOrUndefinedorEmpty(
    selectShoppingCartState(state)?.googlePayPaymentRequest,
  );
};

export const selectMsgForListAndRegistry = (state: any) => {
  return state.cart.msgForListAndRegistry;
};

export const selectOrderID = (state: CartState) => {
  return selectHeader(state)?.orderId;
};
